import { gql } from '@apollo/client';

export const FETCH_ALL_FORMULARY_QUERY = gql`
  query fetchAllFormulary($sourceUrl: String) {
    fetchAllFormulary(sourceUrl: $sourceUrl) {
      id
      manufacturer {
        display
        reference
        identifier {
          use
          system
          value
        }
      }
      identifier {
        use
        system
        value
      }
      code {
        coding {
          system
          code
          display
        }
        text
        system
        code
      }
      extension {
        url
        valueString
        valueReference {
          type
          display
          reference
        }
      }
    }
  }
`;
export const FETCH_FORMULARY_BY_ID = gql`
  query fetchFormularyById($formularyId: String) {
    fetchFormularyById(formularyId: $formularyId) {
      id
      identifier {
        use
        system
        value
      }
      code {
        coding {
          system
          code
          display
        }
        text
      }
      manufacturer {
        reference
        display
      }
      extension {
        url
        extension {
          url
          valueString
          valueCoding {
            display
          }
        }
      }
    }
  }
`;
